"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * DocumentOfTheDayModel represent the retronews "Document du jour" concept
 */
module.exports=Backbone.Model.extend({
  
    rnapi:null,

    defaults: {
        publicationId:0,
        documentId:0,
        publicationTitle:null,
        publicationDate:null
    },

    urlRoot:function(){
        return this.rnapi+"/document-of-the-day";
    },

    /**
     * @param  {object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    }

});